import React from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { useRootStore } from "../../../../store/contexts";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { FormSaveFooter } from "../../../../common/controls/forms/FormSaveFooter";

import FormExtras from "../../../../common/components/formExtras";
import { MusicalGenreCreateStore } from "../../store";
import { InputString } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type MusicalGenreCreateFormProps = {
  onSave?: () => void;
  onCancel?: () => void;
  /** Mientras se guarda, Guardar queda deshabilitado. */
  saving?: boolean;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
  nameSelectedValue?: { displayId: string; id: string } | null;
  onNameChange?: (value: string) => void;
  name: string;
  nameError?: string;
  musicalGenreCreateStore: MusicalGenreCreateStore;
};

export const MusicalGenreCreateForm: React.FC<MusicalGenreCreateFormProps> =
  observer(
    ({
      onSave = () => {},
      onCancel = () => {},
      saving = false,
      showToolbox = true,
      showSaveFooter,
      name = "",
      nameError,
      onNameChange = () => {},
      musicalGenreCreateStore,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              saveAndCloseLabel={langStore.saveEntity}
              closeLabel={langStore.cancelNewEntity}
              saveForm={() => onSave()}
              saveDisabled={saving}
              closeForm={() => onCancel()}
            />
          )}
          <Box>
            <FormExtras
              entity="MusicalGenre"
              mode="create"
              values={{}}
              options={{}}
              onPatch={(campo: string, valor: any) => {
                switch (campo) {
                  case "name":
                    onNameChange?.(valor);
                    break;
                }
              }}
            />
            <GroupContainer
              id="null"
              errorText={musicalGenreCreateStore.getCardErrors("null")}
              title={langStore.groupMusicalGenreLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <InputString
                  autoFocus
                  value={name}
                  error={Boolean(nameError)}
                  warning={
                    !nameError &&
                    Boolean(musicalGenreCreateStore.warnings["name"])
                  }
                  helperText={
                    nameError ||
                    musicalGenreCreateStore.warnings["name"]?.message
                  }
                  label={langStore.MusicalGenreNameLabel}
                  onChange={(value: string) => onNameChange(value)}
                  description={langStore.MusicalGenreNameDescription}
                />
              </FormControl>
            </GroupContainer>
          </Box>
          {(showSaveFooter ?? !showToolbox) && (
            <FormSaveFooter
              onSave={() => onSave()}
              label={langStore.saveEntity}
              disabled={saving}
            />
          )}
        </Grid>
      );
    }
  );
